module.exports = __webpack_public_path__ + "static/images/already-receive0.c647368.png";